import useSWR, { useSWRConfig } from 'swr'

const urlsToMutate = [];

const mutateUrls = (swrConfig) => {
    var urlToMutate;
    while (urlsToMutate.length > 0) {
        urlToMutate = urlsToMutate.pop();

        var revalidate = urlToMutate.data === null;
        swrConfig.mutate(urlToMutate.url, urlToMutate.data, revalidate);
    }
}

const useMutateUrls = () => {
    const swrConfig = useSWRConfig();
    mutateUrls(swrConfig);
}

const useGenericSWR = (url, dataClient, swrOptions = {}) => {
    const swrConfig = useSWRConfig();

    dataClient.swrConfig = swrConfig;

    useMutateUrls();

    if (swrOptions.refreshInterval > 0) {
        dataClient.cacheExirationMs = swrOptions.refreshInterval;
    }

    const {
        data,
        error,
        isValidating,
        mutate,
    } = useSWR(url, dataClient.fetcher, { ...swrOptions, revalidateOnMount: true });

    if (dataClient.customDataHandler) {
        let customResult = dataClient.customDataHandler(data, error, isValidating);
        customResult.refetchResult = mutate;
        return customResult;
    }

    return {
            result: data?.result || data,
            groupings: data ? data.groupings : null,
            rowCount: data ? data.totalCount : 0,
            totalCount: data ? data.totalCount : 0,
            skip: data ? data.skip : 0,
            take: data ? data.take : 0,
            isLoading: !error && !data,
            isError: !(!error),
            error: error,
            isValidating: isValidating,
            refetchResult: mutate,
        };
};

export {
    useGenericSWR,
    useMutateUrls,
    mutateUrls,
    urlsToMutate,
}
